import { CurlyBraces } from "./ConsoleSvg";

interface CommandDataHeaderProps {
    isCommandDataJson: boolean;
    selectedTelecommand: unknown;
    onToggleClick: () => void;
}

const CommandDataHeader = ({ isCommandDataJson, selectedTelecommand, onToggleClick }: CommandDataHeaderProps) => (
    <div className="command_data_header_container">
        <div className="command_data_header_text">Command Data</div>
        <button
            className={`command_data_toggle_btn ${isCommandDataJson ? "active" : ""} ${!selectedTelecommand ? "disabled" : ""}`}
            onClick={onToggleClick}
            disabled={!selectedTelecommand}
        >
            <CurlyBraces />
        </button>
    </div>
);

export default CommandDataHeader;
